import { render } from "./ViewAllReports.vue?vue&type=template&id=22afcb91&scoped=true"
import script from "./ViewAllReports.vue?vue&type=script&lang=js"
export * from "./ViewAllReports.vue?vue&type=script&lang=js"

import "./ViewAllReports.vue?vue&type=style&index=0&id=22afcb91&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22afcb91"]])

export default __exports__